import { Flex, TabList, Tabs, Tab, Switch, Text, useBreakpointValue } from '@chakra-ui/react';
import { FC } from 'react';
import { useLocalStorage } from 'react-use';

import { TABS, VIEW_TYPE_KEY, ViewType } from '@/components/ui/features/schedule/static';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import useSession from '@/hooks/useSession';

interface IScheduleTabsParams {
  active_tab: string;
  view_type: ViewType;
}

export const ScheduleTabsHeader: FC = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { thinProfile } = useSession();
  const { active_tab, view_type, change } = useQueryParams<IScheduleTabsParams>({
    active_tab: StringParam,
    view_type: StringParam,
  });

  const [_, setViewTypeLocal] = useLocalStorage(VIEW_TYPE_KEY, ViewType.CALENDAR);

  function changeViewType() {
    const newViewType = view_type === ViewType.CALENDAR ? ViewType.LIST : ViewType.CALENDAR;

    setViewTypeLocal(newViewType);
    change({ view_type: newViewType, active_tab }, { shallow: true, method: 'replace' });
  }

  function changeTab(tabIndex: number) {
    const newTab = TABS[tabIndex];

    change({ view_type, active_tab: newTab }, { shallow: true, method: 'replace' });
  }

  return (
    <Flex px={4} justifyContent="space-between" alignItems="center" borderBottom="1px solid #CCCCCC">
      <Tabs onChange={changeTab} index={TABS.indexOf(active_tab || 'schedule')}>
        <TabList border="none">
          <Tab fontSize="xl">{TABS[0]}</Tab>
          {thinProfile && <Tab fontSize="xl">{TABS[1]}</Tab>}
        </TabList>
      </Tabs>
      {!isMobile && (
        <Flex gap={2} fontWeight="semibold">
          <Text color={view_type === ViewType.CALENDAR ? 'violet.500' : 'gray.500'}>CALENDAR</Text>
          <Switch variant="narrowTrack" isChecked={view_type !== ViewType.CALENDAR} onChange={changeViewType} />
          <Text color={view_type === ViewType.LIST ? 'violet.500' : 'gray.500'}>LIST</Text>
        </Flex>
      )}
    </Flex>
  );
};
